import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'
import { AlmanacFileCalendarItem } from '../calendar/types'

type Props = {
  designId: string
}

type Data = AlmanacFileCalendarItem

type Variables = {
  media_file_key?: string
  generation_data?: Record<string, unknown>
  slide_index?: number
}

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const replaceMedia = async (
  workspaceId: number,
  designId: string,
  mediaFileKey?: string,
  generationData?: Record<string, unknown>,
  slideIndex?: number,
) => {
  const requestBody: Record<string, unknown> = {}
  if (mediaFileKey) {
    requestBody.media_file_key = mediaFileKey
  }
  if (generationData) {
    requestBody.generation_data = generationData
  }
  if (slideIndex !== undefined) {
    requestBody.slide_index = slideIndex
  }

  const res = await sendToApi(`/w/${workspaceId}/designs/${designId}/replace_media`, {
    method: 'POST',
    body: requestBody,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useReplaceMedia = ({ designId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>(
    (params) => replaceMedia(workspaceId, designId, params.media_file_key, params.generation_data, params.slide_index),
    options,
  )
}
